import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListFaktura extends GuiListGeneric {

    constructor() {
        super("Faktura");
    }

}
